import React from 'react';

import { EnergyLabel } from '@aoworld-aotech/components-react';

const EnergyLabelSvg = ({ energyRatingDetails, is2020Label, classes }) => {
	const { EnergyRating, EnergyRatingLabelUrl, MaxEnergyRating } =
		energyRatingDetails;

	if (!EnergyRating) {
		return null;
	}

	const energyRatingArray = EnergyRating?.split('/');

	return (
		<EnergyLabel
			data-testid="energy-rating-link-updated-component"
			href={EnergyRatingLabelUrl}
			rating={energyRatingArray}
			highestRating={MaxEnergyRating}
			className={`text-base cursor-pointer z-10 relative leading-none mr-1 ${classes}`}
			use2020Label={is2020Label}
			modalProps={{ className: 'energy-label-modal ' }}
		/>
	);
};

export default EnergyLabelSvg;
